<template>
  <ClicColInterno
    md="12"
    :cp="cp"
    :key="componentKey"
    containerStyle="height: 100%;width: 100%;"
  >
    <b-row style="height: 100%;" class="p-1">
      <b-col class="p-1" style="height: 100%; position: relative;">
        <div v-if="carregando" class="metabase-status">
          <b-spinner small variant="primary" />
          <span class="ml-2">Carregando dashboard...</span>
        </div>

        <div v-else-if="erro" class="metabase-status text-danger">
          {{ erro }}
        </div>

        <iframe
          v-else
          :src="iframeUrl"
          frameborder="0"
          allowtransparency
          style="height: 100%; width: 100%;"
        ></iframe>
      </b-col>
    </b-row>
  </ClicColInterno>
</template>

<script>

import ComponentMixin from '../../core/ComponentMixin';
import { BRow, BCol, BButton, BModal, BSpinner } from 'bootstrap-vue';

export default {
  name: 'ClicMetabaseChart',
  mixins: [ComponentMixin],
  components: { BRow, BCol, BButton, BModal, BSpinner },
  data() {
    return {
      public: {
        dataRefresh  : this.getEmbedUrl,
      },
      urlAssinada     : null,
      iframeUrl       : null,
      carregando      : true,
      erro            : null,
      renovacaoTimer  : null,
      showModal       : false
    };
  },

  mounted() {
    this.getEmbedUrl();
  },

  beforeDestroy() {
    clearTimeout(this.renovacaoTimer);
  },

  methods: {

    /**
     * Solicita ao backend a URL de embed já assinada. A chave secreta do Metabase
     * nunca trafega para o frontend: o backend resolve a hierarquia do usuário
     * logado e assina os parâmetros travados no JWT.
     */
    async getEmbedUrl() {
      // indicador: qual dashboard padrão ('vendas', 'crm', 'agenda', 'inteligenciamercado'); o backend usa o
      // dashboard instalado para este ambiente. metabaseDashboardId: formato antigo (id), aceito só se o dashboard for
      // deste ambiente; sai quando todas as telas usarem o indicador
      if (!this.indicador && !this.metabaseDashboardId) {
        this.erro = 'Dashboard não configurado.';
        this.carregando = false;
        return;
      }

      this.carregando = true;
      this.erro = null;

      const options = {
        method  : 'POST',
        url     : `https://${this.$host.subdominio}.clictecnologia.com.br/api/sys/metabaseembed`,
        headers : { 'content-type': 'application/json' },
        data    : this.indicador
          ? { indicador: this.indicador }
          : { dashboardId: this.metabaseDashboardId }
      };

      try {
        const response = await this.$axios.request(options);
        const { iframeUrl, expiraEm } = response.data.dados || {};

        // Indicador não instalado no ambiente, usuário sem representante...: a mensagem do backend
        if (!iframeUrl && response.data.mensagem) {
          this.erro = response.data.mensagem;
          return;
        }
        if (!iframeUrl) { throw new Error('Resposta sem iframeUrl'); }

        this.urlAssinada = iframeUrl;
        this.montarUrl();
        this.agendarRenovacao(expiraEm);
      } catch (e) {
        console.error('[ClicMetabaseChart] Erro ao obter a URL de embed:', e);
        this.erro = 'Não foi possível carregar o dashboard. Tente novamente mais tarde.';
      } finally {
        this.carregando = false;
      }
    },

    /**
     * Monta a URL final a partir das três partes que o Metabase espera:
     *   - token   : carrega os parâmetros travados (assinados pelo backend)
     *   - query   : parâmetros editáveis, que o usuário pode alterar
     *   - hash    : aparência, não afeta os dados
     *
     * Filtros editáveis NÃO podem ir no token: o Metabase recusa um valor
     * assinado para parâmetro que não esteja travado.
     */
    montarUrl() {
      if (!this.urlAssinada) { return; }

      const aparencia = [
        `bordered=${this.bordered}`,
        `titled=${this.titled}`,
        `theme=${this.theme}`
      ];

      this.iframeUrl = `${this.urlAssinada}#${aparencia.join('&')}`;
    },

    /**
     * O token de embed expira. Renova a URL um pouco antes para o iframe
     * não quebrar com o dashboard aberto na tela.
     */
    agendarRenovacao(expiraEm) {
      clearTimeout(this.renovacaoTimer);
      if (!expiraEm) { return; }

      const margem = 60 * 1000;
      const atraso = (expiraEm * 1000) - Date.now() - margem;

      if (atraso > 0) {
        this.renovacaoTimer = setTimeout(() => this.getEmbedUrl(), atraso);
      }
    },
  }
};
</script>


<style>
.metabase-status {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.chart-overlay {
  display: flex;
  position: absolute;
  top: 10px;
  right: 25px;
  cursor: pointer;
  z-index: 10;
  align-items: center;
  justify-content: center;
}
</style>
